import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Organization, User } from '@paragon/contract-library';

interface OrganizationsState {
  readonly userOrganization: Organization | null;
  readonly usersInOrganization: readonly User[] | null;
  readonly visibleOrganizations: readonly string[];
}

const initialState: OrganizationsState = {
  userOrganization: null,
  usersInOrganization: null,
  visibleOrganizations: [],
};

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setUserOrganization: (state, action: PayloadAction<Organization>) => {
      state.userOrganization = castDraft(action.payload);
    },
    setUsersInOrganization: (state, action: PayloadAction<readonly User[]>) => {
      state.usersInOrganization = castDraft(action.payload);
    },
    setVisibleOrganizations: (state, action: PayloadAction<readonly string[]>) => {
      state.visibleOrganizations = castDraft(action.payload);
    },
  },
});

export const { setUserOrganization, setUsersInOrganization, setVisibleOrganizations } = organizationsSlice.actions;
export const organizations = organizationsSlice.reducer;
